import { axiosInstance } from './req';

export const getDeviceFirmwareUpdate = async (deviceUUID: string) => {
    return axiosInstance.get(`/api/firmwares/update/${deviceUUID}`).then(({ data }) => data.data || null);
};

export const updateDeviceFirmware = async (deviceUUID: string, firmware: string) => {
    return axiosInstance
        .post(`/api/firmwares/update/${deviceUUID}`, { firmware })
        .then(({ data }) => data.data || null);
};
